// CONSTANTS
import { CustomerValueAddedServiceCode, ValueAddedServiceCode } from '~/apiClient';

const CUSTOMER_TO_VAS_CODE_MAP: Record<CustomerValueAddedServiceCode, ValueAddedServiceCode> = {
    [CustomerValueAddedServiceCode.LogisticsService]: ValueAddedServiceCode.LogisticsService,
    [CustomerValueAddedServiceCode.ProvisionalLicensePlate]: ValueAddedServiceCode.ProvisionalLicensePlate,
    [CustomerValueAddedServiceCode.VehicleNationalization]: ValueAddedServiceCode.VehicleNationalization,
    [CustomerValueAddedServiceCode.VehicleRegistration]: ValueAddedServiceCode.VehicleRegistration,
    [CustomerValueAddedServiceCode.PowertrainWarranty]: ValueAddedServiceCode.PowertrainWarranty,
    [CustomerValueAddedServiceCode.FleequidCare]: ValueAddedServiceCode.FleequidCare,
};

export const convertToVasCode = (customerVasCode: CustomerValueAddedServiceCode): ValueAddedServiceCode => CUSTOMER_TO_VAS_CODE_MAP[customerVasCode];
